"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Skeleton: function() {
        return _Skeleton.Skeleton;
    },
    renderSkeleton_unstable: function() {
        return _Skeleton.renderSkeleton_unstable;
    },
    skeletonClassNames: function() {
        return _Skeleton.skeletonClassNames;
    },
    useSkeletonStyles_unstable: function() {
        return _Skeleton.useSkeletonStyles_unstable;
    },
    useSkeleton_unstable: function() {
        return _Skeleton.useSkeleton_unstable;
    },
    SkeletonItem: function() {
        return _SkeletonItem.SkeletonItem;
    },
    renderSkeletonItem_unstable: function() {
        return _SkeletonItem.renderSkeletonItem_unstable;
    },
    skeletonItemClassNames: function() {
        return _SkeletonItem.skeletonItemClassNames;
    },
    useSkeletonItemStyles_unstable: function() {
        return _SkeletonItem.useSkeletonItemStyles_unstable;
    },
    useSkeletonItem_unstable: function() {
        return _SkeletonItem.useSkeletonItem_unstable;
    },
    SkeletonContextProvider: function() {
        return _index.SkeletonContextProvider;
    },
    useSkeletonContext: function() {
        return _index.useSkeletonContext;
    }
});
const _Skeleton = require("./Skeleton");
const _SkeletonItem = require("./SkeletonItem");
const _index = require("./contexts/index");
